import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const ExtensiveMockTour = ({ autoStart = true, onComplete  }) => {
  const { startTour } = useShepherdTour('extensive_mocks', TOUR_DATA.extensive_mocks.steps, autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Extensive Mock Tour
    </button> */}
    </>
  );
};

export default ExtensiveMockTour;